import { html, TemplateResult } from "lit-html";

export const OnboardingTooltipTemplate = (props: IOnboardingTooltipProps): TemplateResult => {

  const { messages: { OnboardingTooltipTitle, OnboardingTooltipSubtitle }, close } = props;

  return html`
    <div class="highlight-tooltip">
      <p class="onboarding-tooltip-title">
        <strong>${OnboardingTooltipTitle}</strong>
      </p>
      <p class="onboarding-tooltip-subtitle">
        ${OnboardingTooltipSubtitle}
      </p>
      <i @click=${close} class="icon-close"></i>
    </div>
  `;
}